import { makeStyles, tokens } from '@fluentui/react-components';

export const useLoadingLayerStyles = makeStyles({
  root: {
    display: 'grid',
    placeItems: 'center',
    height: '100%',
  },
  marginBottom: {
    marginBottom: tokens.spacingVerticalM,
  }
});
